import React from "react";
import axios from 'axios';

import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import './../MoneyTransferComponent/Subtransaction.css';
import './../MoneyTransferComponent/MoneyTransfer.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import $ from "jquery";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import { Link } from "react-router-dom";

import { setMoneyTransferProgress, setTxnAmount, setTxnsurcharge, setTxntotalAmount, setStatusEnqResponse, setMoneyTransferTotalAmount, setTxnAmount1, setTxnsurcharge1, setTxntotalAmount1, setMoneyTransferProgress1, setStatusEnqResponse1 } from '../../redux/recharge/recharge.action';
import ProgressGif from '../../assests/images/progress.gif';
import ProgressStatic from '../../assests/images/progress.jpg';
import MtFailed from '../../assests/images/mtfailed.png';
import MtSuccess from '../../assests/images/mtsuccess.png';
import MtPartial from '../../assests/images/mtpartial.png';
import HeaderCommon from '../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
import tokenErrorHandler from "../tokenErrorHandler";

const httpClient = axios.create();

class RechargeDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			moneyTransferFinalStatusCompleted: false,
			finalTransferMessage: '',
			counter: 0,
			exceptionCounter: 0,
			moneyTransferProgress1: '',
			orderResDisplayMsg: '',
			orderResThirdPartyRespMsg: '',
		}
	}


	componentDidMount() {

		store.dispatch(setTxnAmount1(''));
		store.dispatch(setTxnsurcharge1(''));
		store.dispatch(setTxntotalAmount1(''));
		// store.dispatch(setMoneyTransferTotalAmount(''));

		store.dispatch(setMoneyTransferProgress1(''));
		store.dispatch(setStatusEnqResponse1(''));

		setTimeout(() => {
			var statusEnqInterval = setInterval(() => {
				this.statusEnquiry1(statusEnqInterval);

			}, 5000)
		}, 5000)

	}


	statusEnquiry1 = (statusEnqInterval) => {




		if (this.state.counter <= 23 && this.state.exceptionCounter <= 11) {

			if (this.state.moneyTransferProgress1 == 'pending'
				|| this.state.moneyTransferProgress1 == ''
				|| this.state.moneyTransferProgress1 == 'start') {

				var counter = this.state.counter;
				counter++;
				this.setState({
					counter: counter,
					progess: 'start',
					moneyTransferProgress1: 'start'
				})

				var enquiryUrl = '';
				if (this.props.rechargeType == 'mobile') {
					enquiryUrl = '/api/v1/proxy/mobile/order/enquiry/order-id/'
						+ this.props.createOrderRes1.orderId

						;
				}
				if (this.props.rechargeType == 'dth') {
					enquiryUrl = '/api/v1/dth/order/enquiry/order-id/'
						+ this.props.createOrderRes1.orderId

						;
				}

				const headers = {
					'Authorization': 'Bearer ' + this.props.token,
					'client-id': this.props.agentInfo.id,
					'role': this.props.clientRole
				}


				httpClient.get(enquiryUrl, {
					timeout: 60 * 1000,
					timeoutErrorMessage: 'timeout',
					headers
				}
				).then((response) => {





					console.log('enquiry response' + JSON.stringify(response.data));
					if (response.data.response.msg != '' &&
						response.data.response.msg != 'undefined' &&
						response.data.response.msg != null) {
						console.log('enquiry service success response:' + JSON.stringify(response.data));
						store.dispatch(setStatusEnqResponse1(response.data));

						this.setState({
							orderResDisplayMsg: response.data.response.displayMsg,
							orderResThirdPartyRespMsg: response.data.response.tpsRspMsg,
						})

						var txnAmount = 0;
						var surcharge = 0;
						var status = response.data.response.msg;


						if (status == 'SUCCESS') {
							this.setState({
								progess: 'finished',
								moneyTransferProgress1: 'finished'
							})



						} else if (status == 'FAILED' ||
							status == 'FAIL' || status == 'INTERNAL_FAILURE' ||
							status == 'SUCCESS_TO_FAILED' ||
							status == 'NOT_FOUND') {
							this.setState({
								progess: 'failed',
								moneyTransferProgress1: 'failed'
							})

						} else if (status == 'PENDING'
							|| status == 'ACCEPTED'
							|| status == 'PROCESSING'
							|| status == 'HUNG'
							|| status == 'SYSTEM_BUSY'
						) {
							this.setState({
								progess: 'pending',
								moneyTransferProgress1: 'pending'
							})

						} else if (status == 'AUTO_REVERSED'
							|| status == 'MANUALLY_REVERSED'
						) {
							this.setState({
								progess: 'pending',
								moneyTransferProgress1: 'reversed'
							})

						}
						else {
							this.setState({
								progess: 'pending',
								moneyTransferProgress1: 'pending'
							})

						}
					} else {
						store.dispatch(setStatusEnqResponse1(response.data));
						console.log('enquiry service other response :' + JSON.stringify(response.data))
						this.setState({
							progess: 'pending',
							moneyTransferProgress1: 'pending'
						})


					}
					//
				}).catch(error => {

					this.setState({
						progess: 'pending',
						moneyTransferProgress1: 'success'
					})
					console.log('enquiry response error::' + error);
					var exceptionCounter = this.state.exceptionCounter;
					exceptionCounter++;
					this.setState({
						exceptionCounter: exceptionCounter
					})
				})
			}
		} else {

			if (this.state.counter > 23) {
				this.setState({
					moneyTransferProgress1: 'statusEnquirycompletedInpendingStatus'
				})

			}
			if (this.state.exceptionCounter > 11) {
				this.setState({
					moneyTransferProgress1: 'exception-pending'
				})

			}
			console.log('clear interval');
			clearInterval(statusEnqInterval);



		}
	}





	statusEnquiry = () => {

		if (this.state.moneyTransferProgress1 == 'pending'
			|| this.state.moneyTransferProgress1 == ''
			|| this.state.moneyTransferProgress1 == 'start') {


			this.setState({
				progess: 'start'
			});

			// this.setState({
			// 	orderResDisplayMsg: '',
			// 	orderResThirdPartyRespMsg: '',
			// })

			store.dispatch(setMoneyTransferProgress1('start'));

			var enquiryUrl = '/api/v1/proxy/mobile/order/enquiry/order-id/1234';
			// if (this.props.rechargeType == 'mobile') {
			// 	enquiryUrl = '/api/v1/proxy/mobile/order/enquiry/order-id/'
			// 		+ this.props.createOrderRes1.orderId
			// 		;
			// }
			// if (this.props.rechargeType == 'dth') {
			// 	enquiryUrl = '/api/v1/dth/order/enquiry/order-id/'
			// 		+ this.props.createOrderRes1.orderId
			// 		;
			// }

			const headers = {
				'Authorization': 'Bearer ' + 1234,
				'client-id': 1234,
				'role': this.props.clientRole
			}


			httpClient.get(enquiryUrl, {
				timeout: 60 * 1000,
				timeoutErrorMessage: 'timeout',
				headers
			}
			).then((response) => {



				console.log('enquiry response' + JSON.stringify(response.data));
				if (response.data.response.msg != '' &&
					response.data.response.msg != 'undefined' &&
					response.data.response.msg != null) {
					console.log('enquiry service success response:' + JSON.stringify(response.data));
					store.dispatch(setStatusEnqResponse1(response.data));

					this.setState({
						orderResDisplayMsg: response.data.response.displayMsg,
						orderResThirdPartyRespMsg: response.data.response.tpsRspMsg,
					})

					var txnAmount = 0;
					var surcharge = 0;
					var status = response.data.response.msg;


					if (status == 'SUCCESS') {
						this.setState({
							progess: 'finished',
							moneyTransferProgress1: 'finished'
						})



					} else if (status == 'FAILED' ||
						status == 'FAIL' || status == 'INTERNAL_FAILURE' ||
						status == 'SUCCESS_TO_FAILED' ||
						status == 'NOT_FOUND') {
						this.setState({
							progess: 'failed',
							moneyTransferProgress1: 'failed'
						})

					} else if (status == 'PENDING'
						|| status == 'ACCEPTED'
						|| status == 'PROCESSING'
						|| status == 'HUNG'
						|| status == 'SYSTEM_BUSY'
					) {
						this.setState({
							progess: 'pending',
							moneyTransferProgress1: 'pending'
						})

					} else if (status == 'AUTO_REVERSED'
						|| status == 'MANUALLY_REVERSED'
					) {
						this.setState({
							progess: 'pending',
							moneyTransferProgress1: 'reversed'
						})

					}
					else {
						this.setState({
							progess: 'pending',
							moneyTransferProgress1: 'pending'
						})

					}
				} else {
					store.dispatch(setStatusEnqResponse1(response.data));
					console.log('enquiry service other response :' + JSON.stringify(response.data))
					this.setState({
						progess: 'pending',
						moneyTransferProgress1: 'pending'
					})


				}
				//
			}).catch(error => {

				this.setState({
					progess: 'pending',
					moneyTransferProgress1: 'failed'
				})


				console.log('enquiry response error::' + error);
				var exceptionCounter = this.state.exceptionCounter;
				exceptionCounter++;
				this.setState({
					exceptionCounter: exceptionCounter
				})
			})
		}
	}


	componentWillUnmount() {
	}


	print = (event) => {
		event.preventDefault();
		window.print();
	}




	render() {


		return (

			<div>
				<HeaderCommon />
				<Menu />
				<div class="main">
					<div class="right-side">
						<div class="container-fluid">
							<div class="row">
								<div class="col-12">
									<div class="card-b" id="rightdiv">
										<div id="recenttxn">
											<div class="head">
												<h3>Recharge Details</h3>
												<Link to='/recharge'>
													<button class="dbbtn" type="button">Back</button>
												</Link>
											</div>

											<div class="benedtls">
												<div class="row">
													<div class="col-12 col-lg-4 order-lg-2">
														{(this.state.moneyTransferProgress1 == 'statusEnquirycompletedInpendingStatus') &&
															<div class="mtprogess" id="mtrun">
																<img src={MtSuccess} alt="process" class="img-fluid" />
																<h3 class="pending">Transaction Success, under process</h3>
															</div>
														}
														{(this.state.moneyTransferProgress1 == '' ||
															this.state.moneyTransferProgress1 == 'pending' ||
															this.state.moneyTransferProgress1 == 'start') &&
															<div class="mtprogess" id="mtrun">
																<img src={ProgressGif} alt="process" class="img-fluid" />
																<h3 class="pending">Transaction in process...Please don't refresh</h3>
															</div>
														}
														{this.state.moneyTransferProgress1 == 'finished' &&
															<div class="mtprogess" id="mtdone">
																<img src={MtSuccess} alt="process" class="img-fluid" />
																<h3 class='success'>Transaction successful</h3>
															</div>
														}
														{this.state.moneyTransferProgress1 == 'failed' &&
															<div class="mtprogess" id="mtfailed">
																<img src={MtFailed} alt="process" class="img-fluid" />
																<h3 class="failed">Transaction failed</h3>
															</div>
														}
														{this.state.moneyTransferProgress1 == 'reversed' &&
															<div class="mtprogess" id="mtfailed">
																<img src={MtSuccess} alt="process" class="img-fluid" />
																<h3 class="pending">Transaction reversed</h3>
															</div>
														}
														{this.state.moneyTransferProgress1 == 'exception-pending' &&
															<div class="mtprogess" id="mtfailed">
																<img src={MtPartial} alt="process" class="img-fluid" />
																<h3 class="pending">Transaction pending</h3>
															</div>
														}

													</div>
													<div class="col-12 col-md-6 col-lg-4 order-lg-1">
														<div class="graycard">
															<div class="bankdtl">
																{/* <Avatar name={this.props.selectSender.customer.name} round={true} size="44" alt="" /> */}
																<h5>Operator Name</h5>
																<p>{this.props.selectedOperator}</p>
															</div>
															<hr />
															<div class="bankdtl">
																<h5>Mobile Number</h5>
																<p>{this.props.rechargeMobileNo}</p>
															</div>
														</div>
													</div>

													<div class="col-12 col-md-6 col-lg-4 order-lg-3">
														<div class="graycard">
															<div class="bankdtl">
																<h5>Retailer Id</h5>
																<p>{this.props.agentInfo.id}</p>
															</div>
															<hr />
															<div class="acntifsc">
																<h5>Retailer Name</h5>
																<p>{this.props.agentInfo.kioskName}</p>
															</div>

															<div class="acntifsc rtxt">
																<h5>Kiosk Code</h5>
																<p>{this.props.agentInfo.kioskCode}</p>
															</div>
														</div>
													</div>
												</div>
											</div>


											<div class="subtxn">
												<h4>Sub Transactions</h4>

												{(this.state.moneyTransferProgress1 != null &&
													this.state.moneyTransferProgress1 != undefined &&
													this.state.moneyTransferProgress1 != '') &&
													(this.state.moneyTransferProgress1 == 'finished'
													) ?
													<div class='subtxn-success'>
														<div class="col-6 col-md-3 col-lg-3 order-md-1">
															<div class="subtxt txnsts">{'Successful'}</div>
														</div>
														<div class="row">
															<div class="col-6 col-md-2 col-lg-4 order-md-4">
																<div class="subtxt subamunt rtxt">₹ {parseFloat(this.props.transferTotalAmount1)}</div>
															</div>

															<div class="col-12 col-md-4 col-lg-6 order-md-2">
																<div class="subtxt subid">{this.props.createOrderRes1.orderId}</div>
															</div>

															<div class="col-12 col-md-3 col-lg-4 order-md-3">
																<div class="subtxt">{moment(this.props.createOrderStatusResponse1.time).format('DD-MM-YYYY HH:mm:ss')}</div>
															</div>
														</div>
													</div> :
													this.state.moneyTransferProgress1 == 'failed' ?
														<div class='subtxn-failed'>
															<div class="col-6 col-md-3 col-lg-3 order-md-1">
																<div class="subtxt txnsts">{'Failed'}</div>
															</div>




															<div class="row">
																<div class="col-6 col-md-2 col-lg-6 order-md-4">
																	<div class="subtxt subamunt rtxt">₹ {parseFloat(this.props.transferTotalAmount1)}</div>
																</div>

																<div class="col-12 col-md-4 col-lg-4 order-md-2">
																	<div class="subtxt subid">{this.props.createOrderRes1.orderId}</div>
																</div>

																<div class="col-12 col-md-3 col-lg-3 order-md-3">
																	<div class="subtxt">{moment(this.props.createOrderStatusResponse1.time).format('DD-MM-YYYY HH:mm:ss')}</div>
																</div>
															</div>
														</div> :
														this.state.moneyTransferProgress1 == 'reversed' ?
															<div class='subtxn-pending'>
																<div class="col-6 col-md-3 col-lg-3 order-md-1">
																	<div class="subtxt txnsts">{'Reversed'}</div>
																</div>


																<div class="row">
																	<div class="col-6 col-md-2 col-lg-4 order-md-4">
																		<div class="subtxt subamunt rtxt">₹ {parseFloat(this.props.transferTotalAmount1)}</div>
																	</div>

																	<div class="col-12 col-md-4 col-lg-6 order-md-2">
																		<div class="subtxt subid"> {this.props.createOrderRes1.orderId}</div>
																	</div>

																	<div class="col-12 col-md-3 col-lg-4 order-md-3">
																		<div class="subtxt">{moment(this.props.createOrderStatusResponse1.time).format('DD-MM-YYYY HH:mm:ss')}</div>
																	</div>
																</div>
															</div> :
															(this.state.moneyTransferProgress1 == 'pending' ||
																this.state.moneyTransferProgress1 == 'exception-pending')
																?
																<div class='subtxn-pending'>
																	<div class="col-6 col-md-3 col-lg-3 order-md-1">
																		<div class="subtxt txnsts">{'Pending'}</div>
																	</div>


																	<div class="row">
																		<div class="col-6 col-md-2 col-lg-4 order-md-4">
																			<div class="subtxt subamunt rtxt">₹ {parseFloat(this.props.transferTotalAmount1)}</div>
																		</div>

																		<div class="col-12 col-md-4 col-lg-6 order-md-2">
																			<div class="subtxt subid">{this.props.createOrderRes1.orderId}</div>
																		</div>

																		<div class="col-12 col-md-3 col-lg-4 order-md-3">
																			<div class="subtxt">{moment(this.props.createOrderStatusResponse1.time).format('DD-MM-YYYY HH:mm:ss')}</div>
																		</div>
																	</div>
																</div> :
																this.state.moneyTransferProgress1 == 'statusEnquirycompletedInpendingStatus' ?
																	<div class='subtxn-pending'>
																		<div class="col-6 col-md-3 col-lg-3 order-md-1">
																			<div class="subtxt txnsts">{'Transaction Success(Under process)'}</div>
																		</div>


																		<div class="row">
																			<div class="col-6 col-md-2 col-lg-4 order-md-4">
																				<div class="subtxt subamunt rtxt">₹ {parseFloat(this.props.transferTotalAmount1)}</div>
																			</div>

																			<div class="col-12 col-md-4 col-lg-6 order-md-2">
																				<div class="subtxt subid"> {this.props.createOrderRes1.orderId}</div>
																			</div>

																			<div class="col-12 col-md-3 col-lg-4 order-md-3">
																				<div class="subtxt">{moment(this.props.createOrderStatusResponse1.time).format('DD-MM-YYYY HH:mm:ss')}</div>
																			</div>
																		</div>
																	</div> :
																	<div class='subtxn-pending'>
																		<div class="col-6 col-md-3 col-lg-3 order-md-1">
																			<div class="subtxt txnsts">{'Pending'}</div>
																		</div>


																		<div class="row">
																			<div class="col-6 col-md-2 col-lg-4 order-md-4">
																				<div class="subtxt subamunt rtxt">₹ {parseFloat(this.props.transferTotalAmount1)}</div>
																			</div>

																			<div class="col-12 col-md-4 col-lg-6 order-md-2">
																				<div class="subtxt subid">{this.props.createOrderRes1.orderId}</div>
																			</div>

																			<div class="col-12 col-md-3 col-lg-4 order-md-3">
																				<div class="subtxt">{moment(this.props.createOrderStatusResponse1.time).format('DD-MM-YYYY HH:mm:ss')}</div>
																			</div>
																		</div>
																	</div>

												}


												{
													(this.state.moneyTransferProgress1 == 'pending' ||
														this.state.moneyTransferProgress1 == 'exception-pending' ||
														this.state.moneyTransferProgress1 == 'statusEnquirycompletedInpendingStatus' ||
														this.state.moneyTransferProgress1 == 'reversed'
														|| this.state.moneyTransferProgress1 == 'partial success') ?
														<div class="col-12">
															<div class="subtxn-pending">
																{this.state.orderResDisplayMsg != null &&
																	this.state.orderResDisplayMsg != '' &&
																	this.state.orderResDisplayMsg != undefined &&
																	<b> Message:  {this.state.orderResDisplayMsg}
																	</b>
																}
																<br />

																{this.state.orderResThirdPartyRespMsg != null &&
																	this.state.orderResThirdPartyRespMsg != '' &&
																	this.state.orderResThirdPartyRespMsg != undefined &&
																	<b> Third Party Message:  {this.state.orderResThirdPartyRespMsg}
																	</b>
																}

															</div>
															{/* <div class="subtxt txnsts">

															</div> */}
														</div>
														:
														this.state.moneyTransferProgress1 == 'failed' &&
														<div class="col-12">
															<div class="subtxn-failed">
																{this.state.orderResDisplayMsg != null &&
																	this.state.orderResDisplayMsg != '' &&
																	this.state.orderResDisplayMsg != undefined &&
																	<b> Message:  {this.state.orderResDisplayMsg}
																	</b>
																}
																<br />

																{this.state.orderResThirdPartyRespMsg != null &&
																	this.state.orderResThirdPartyRespMsg != '' &&
																	this.state.orderResThirdPartyRespMsg != undefined &&
																	<b> Third Party Message:  {this.state.orderResThirdPartyRespMsg}
																	</b>
																}
															</div>
															{/* <div class="subtxt txnsts">

															</div> */}
														</div>
												}




												{this.props.createOrderRes1 != null &&
													this.props.createOrderRes1 != undefined &&
													this.props.createOrderRes1 != '' &&
													<div class="paydtl">
														<div class="row">
															<div class="col-12 col-sm-6">
																<div class="orderdetail">
																	<div class="txnhead">Order Details</div>
																	<div class="odramt">
																		<p>Order Amount <span>₹ {parseFloat(this.props.transferTotalAmount1).toFixed(2)}</span></p>
																		<p>Commission <span>₹ {parseFloat(this.props.surcharge1).toFixed(2)}</span></p>
																	</div>
																	<div class="ttlamt">
																		<p>Total Amount <span>₹ {parseFloat(this.props.transferTotalAmount1).toFixed(2) - parseFloat(this.props.surcharge1).toFixed(2)}</span></p>
																	</div>
																</div>
															</div>
															<div class="col-12 col-sm-6">
																<div class="tnsfrdetail">
																	<div class="txnhead">Transaction Details</div>
																	<div class="odramt">
																		<p>Transfer Amount <span>₹ {(this.props.transferTotalAmount1 != '' && this.props.surcharge1 != ''
																			&&
																			(this.state.moneyTransferProgress1 == 'finished' ||
																				this.state.moneyTransferProgress1 == 'statusEnquirycompletedInpendingStatus')
																		)
																			? (parseFloat(this.props.transferTotalAmount1).toFixed(2)) : 0.00}</span></p>
																		<p>Commission <span>₹ {(this.props.surcharge1 != ''
																			&&
																			(this.state.moneyTransferProgress1 == 'finished' ||
																				this.state.moneyTransferProgress1 == 'statusEnquirycompletedInpendingStatus')
																		) ? parseFloat(this.props.surcharge1).toFixed(2) : 0.00}</span></p>
																	</div>
																	<div class="ttlamt">
																		<p>Total Amount <span>₹ {(this.props.transferTotalAmount1 != '' && this.props.surcharge1 != ''
																			&&
																			(this.state.moneyTransferProgress1 == 'finished' ||
																				this.state.moneyTransferProgress1 == 'statusEnquirycompletedInpendingStatus')
																		) ?
																			parseFloat(this.props.transferTotalAmount1).toFixed(2) - parseFloat(this.props.surcharge1).toFixed(2) : 0.00}</span></p>
																	</div>
																</div>
															</div>
														</div>
													</div>
												}


												{/* <div class="txn-btn">
												<button type="button" class="print" onClick={this.print}>Print</button>
												<button type="button" class="help"></button>
											</div> */}


											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<FooterComponet />
			</div>

		);
	}
}


const mapStateToProps = (
	{
		errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: {
			phone,
			agentInfo, token, clientRole
		}
		, rechargeReduce: {
			createOrderRes1, transferTotalAmount1, surcharge1,
			txmAmnt,
			txnSurchrg,
			txnTotalAmnt,
			moneyTransferProgress1,
			createOrderStatusResponse1,
			rechargeAmount1, rechargeMobileNo, selectedOperator, selectedCircle, rechargeType
		}

	}

) => ({
	errorMessage, loginErrorMessage, phone,
	agentInfo, token, clientRole,
	createOrderRes1, transferTotalAmount1, surcharge1,

	txmAmnt,
	txnSurchrg,
	txnTotalAmnt,
	moneyTransferProgress1,
	createOrderStatusResponse1,
	rechargeAmount1, rechargeMobileNo, selectedOperator, selectedCircle, rechargeType
});

export default connect(mapStateToProps, null)(RechargeDetails);


